import { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { DefaultLayout } from "../../../../layouts/Default";
import { Main } from "../../../../themes/Default/components/Main";
import { Tabs } from "../../../../themes/Default/components/Tabs";
import { TopNavigation } from "../../../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../../../themes/Default/components/Breadcrumps";
import { Select } from "../../../../themes/Default/components/Form/components/Select";
import { prepareSelect } from "../../../../services/core/Select";
import { Link } from "../../../../themes/Default/components/Breadcrumps/components/Link";
import { Button, ButtonBack } from "../../../../themes/Default/components/TopNavigation/components/Button";
import { Form } from "../../../../themes/Default/components/Form";
import { Row } from "../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../themes/Default/components/Form/components/Row/components/Field";
import { studentsManagement } from "../../../../hooks/api/StudentsManagement";
import { useTranslation } from "react-i18next";
import { Title } from "../../../../themes/Default/components/Title";
import { legalEntityManagement } from "../../../../hooks/api/LegalEntitiesManagement/LegalEntitiesManagement";
import { Input } from "../../../../themes/Default/components/Form/components/Input";
import { toast } from "react-toastify";
import { Toaster } from "../../../../themes/Default/components/Toaster";

const EditContract = () => {
    const { t } = useTranslation("common");
    const { studentId } = useParams();
    const { contractId } = useParams();
    const formRef = useRef(null);
    const [groups, setGroups] = useState([]);
    const [legalEntities, setLegalEntities] = useState([]);
    const [studentFullName, setStudentFullName] = useState([]);
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState([]);
    const { useEditContractMutation, useViewStudentsMutation, useViewContractMutation } = studentsManagement;
    const { useLegalEntityListMutation } = legalEntityManagement;
    const [editContract] = useEditContractMutation();
    
    const [legalEntityList] = useLegalEntityListMutation();
    const [viewStudent] = useViewStudentsMutation();

    const [installmentDate, setInstallmentDate] = useState([]);
    const [paymentStartMonth, setPaymentStartMonth] = useState([]);

    const [viewContract] = useViewContractMutation();

    const tabs = [
        { title: t("details"), onClick: () => gotoDetailsTab(studentId) },
        // { title: t("students.tests"), onClick: () => gotoTestsTab(studentId)},
        { title: t("students.contract"), isActive: true },
        { title: t("calls.title"), onClick: () => gotoCallsTab(studentId) },
        { title: t("groups.title"), onClick: () => gotoGroupsTab(studentId) },
        { title: t("students.certificates"), onClick: () => gotoCertificatesTab(studentId) },
        { title: t("documents"), onClick: () => gotoDocumentsTab(studentId) },
        { title: t("notes"), onClick: () => gotoNotesTab(studentId) },
    ];

    const gotoTestsTab = (studentId) => {
        navigate("/students/" + studentId + "/tests");
    };

    const gotoCallsTab = (studentId) => {
        navigate("/students/" + studentId + "/calls");
    };

    const gotoCertificatesTab = (studentId) => {
        navigate("/students/" + studentId + "/certificates");
    };

    const gotoDetailsTab = (studentId) => {
        navigate("/students/edit/" + studentId);
    };

    const gotoNotesTab = (studentId) => {
        navigate("/students/" + studentId + "/notes");
    };

    const gotoDocumentsTab = (studentId) => {
        navigate("/students/" + studentId + "/documents");
    };

    const gotoGroupsTab = (studentId) => {
        navigate("/students/" + studentId + "/groups");
    };

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        editContract({ body: values, studentId, contractId }).then((result) => {
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                navigate(`/students/${studentId}/contracts`);
            }
        });
    };

    const installmentDates = () => {
        const options = [
            { id: 5, name: "5" },
            { id: 10, name: "10" },
            { id: 15, name: "15" },
            { id: 20, name: "20" },
            { id: 25, name: "25" },
        ];
    
        return prepareSelect(options);
    };
    const paymentStartMonths = () => {
        const options = [
            { id: 1, name: "Januar" },
            { id: 2, name: "Februar" },
            { id: 3, name: "Mart" },
            { id: 4, name: "April" },
            { id: 5, name: "Maj" },
            { id: 6, name: "Jun" },
            { id: 7, name: "Jul" },
            { id: 8, name: "Avgust" },
            { id: 9, name: "Septembar" },
            { id: 10, name: "Oktobar" },
            { id: 11, name: "Novembar" },
            { id: 12, name: "Decembar" }
        ];
    
        return prepareSelect(options);
    };

    useEffect(() => {
        viewContract({ studentId, contractId }).then((result) => {
            formRef.current.setValues(result?.data);
        });

        legalEntityList().then((result) => {
            setLegalEntities(prepareSelect(result?.data?.records));
        });

        viewStudent(studentId).then((result) => {
            setStudentFullName(result?.data?.firstName + ' ' + result?.data?.lastName);
            setGroups(result?.data?.activeGroups);
        });

        setInstallmentDate(installmentDates);
        setPaymentStartMonth(paymentStartMonths);
    }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to={'/students/' + studentId + '/contracts'} />
                <Button title={t("save")} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title>{studentFullName}</Title>
                <Breadcrumps>
                    <Link title={t("students.title")} icon="fa-user-graduate" />
                    <Link title={t("students.contract")} />
                    <Link title={t("details")} />
                    <Link title={t("students.addContract")} isActive={true} />
                </Breadcrumps>
                <Formik
                    innerRef={formRef}
                    initialValues={{
                        group: null,
                    }}
                    onSubmit={onSaved}
                >
                    {({ values, handleChange }) => (
                        <Form>
                            <Row>
                                <Field>
                                    <Select 
                                        name="group" 
                                        label={t('Grupa')} 
                                        onChange={handleChange} 
                                        required={true} 
                                        options={groups} 
                                        selectedValue={values.group}
                                        error={formErrors?.department}
                                        searchInDropdown={false}
                                    />
                                </Field>
                                <Field>
                                    <Select 
                                        name="legalEntity" 
                                        label={t('students.contractLegalEntity')} 
                                        onChange={handleChange} 
                                        required={true} 
                                        options={legalEntities} 
                                        selectedValue={values.legalEntity} 
                                        error={formErrors?.legalEntity}
                                        disabled={true}
                                    />
                                </Field>
                            </Row>
                            <Row>
                                <Field>
                                    <Input
                                        name="totalAmount"
                                        label={t("students.contractTotalAmount")}
                                        required={true}
                                        value={values.totalAmount}
                                        onChange={handleChange}
                                        error={formErrors?.totalAmount}
                                        disabled={true}
                                    />
                                </Field>
                                <Field>
                                    <Input
                                        name="numberOfInstallments"
                                        label={t("students.contractNumberOfInstallments")}
                                        required={true}
                                        value={values.numberOfInstallments}
                                        onChange={handleChange}
                                        error={formErrors?.numberOfInstallments}
                                        disabled={true}
                                    />
                                </Field>
                            </Row>
                            <Row>
                                <Field>
                                    <Select 
                                        name="installmentDates" 
                                        label={t('students.contractInstallmentDates')}
                                        onChange={handleChange} 
                                        options={installmentDate} 
                                        selectedValue={values.installmentDates}
                                        error={formErrors?.installmentDates}
                                        required={true}
                                        disabled={true}
                                    />
                                </Field>
                                <Field>
                                    <Select 
                                        name="paymentStartMonth" 
                                        label={t('students.contractPaymentStartMonth')} 
                                        onChange={handleChange} 
                                        options={paymentStartMonth} 
                                        selectedValue={values.paymentStartMonth} 
                                        error={formErrors?.paymentStartMonth}
                                        required={true}
                                        disabled={true}
                                    />
                                </Field>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default EditContract;
